import { useState } from 'react';
import { MdOutlineKeyboardArrowUp, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import styled from 'styled-components';
import { fontSize } from 'styles/mixins';

type SearchConditionsPanelProps = {
  title: string;
  children: React.ReactNode;
}

const SearchConditionsPanelStyled = styled.div`
  .header {
    align-items: baseline;
    display: flex;
    justify-content: space-between;

    &__title {
      margin: 0;
    }

    &__toggle {
      ${fontSize(10)}
      align-items: center;
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      margin: 0;
      padding: 0;
    }
  }

  .conditions {
    margin-top: 15px;
  }
`

const SearchConditionsPanel = (props: SearchConditionsPanelProps) => {
  const [show, setShow]  = useState<boolean>(true);

  return (
    <SearchConditionsPanelStyled>
      <div className='header'>
        <h1 className='header__title'>{props.title}</h1>
        <button 
          className='header__toggle'
          type='button'
          onClick={() => setShow(prevValue => !prevValue)}
        >
          {show
            ? (<>閉じる<MdOutlineKeyboardArrowDown size='1.8rem' /></>)
            : (<>開く<MdOutlineKeyboardArrowUp size='1.8rem' /></>)
          }
        </button>
      </div>
      <div className='conditions' style={{ display: show ? 'block' : 'none' }}>
        {props.children}
      </div>
    </SearchConditionsPanelStyled>
  );
}

export default SearchConditionsPanel;
